import {Chip} from "primereact/chip";
import {PiPlusBold} from "react-icons/pi";
import {ScrollPanel} from "primereact/scrollpanel";

/**
 * Renders a list of variable chips for selection.
 * Filters out any variables that have no defined `type` or are marked as `autogenerated`.
 */
export default function VariableSelector({availableKeys, error, handleChipClick}) {
	// Only include items with a defined type that is not "autogenerated"
	const filteredKeys = Array.isArray(availableKeys)
		? availableKeys.filter(item => item.type && item.type !== "autogenerated")
		: [];

	return (
		<div className="flex flex-wrap">
			{filteredKeys.length === 0 && (
				<div className="col-12 p-0 mb-1 text-secondary fst-italic">
					{error || "No variables available"}
				</div>
			)}
			{filteredKeys.length > 0 && (
				<div className="col-12 p-0 mb-1 text-secondary fst-italic">Choose variables</div>
			)}
			<ScrollPanel
				style={{
					width: "100%",
					height: "90px",
					overflowX: "auto",
					whiteSpace: "nowrap",
				}}>
				{filteredKeys.map(item => (
					<Chip
						key={item.field_name}
						label={
							<span className="flex align-items-center gap-1">
								{item.field_name} <PiPlusBold size={14} />
							</span>
						}
						className="p-chip m-1 cursor-pointer"
						data-pr-tooltip={item.description}
						data-pr-position="bottom"
						onClick={() => handleChipClick(item)}
					/>
				))}
			</ScrollPanel>
		</div>
	);
}
